import React from "react";
import { useLocation } from "react-router-dom";
import { accountService } from "../../services/accountService";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAward } from "@fortawesome/free-solid-svg-icons";
import { Profile } from "../../models/Profile";

const UserHeader = ({ userProfile }: { userProfile: Profile | undefined }) => {
  const location = useLocation();
  const profileUser = location.pathname.substring(
    location.pathname.lastIndexOf("/") + 1
  );
  const user = accountService.userValue;
  const isUserProfile = profileUser === user?.userName;

  const professionalUser = userProfile?.isProfessional && (
    <p style={{ fontSize: 15 }}>
      <FontAwesomeIcon
        color="blue"
        style={{ fontSize: 15, marginRight: 5 }}
        icon={faAward}
      />
      Certyfikowany specjalista
    </p>
  );

  return (
    <div
      className="text-dark shadow-box"
      style={{
        background: "#fae4e7",
        color: "black",
        width: "100%",
        display: "inline-block",
        padding: 10,
        fontSize: 20,
      }}
    >
      {isUserProfile ? "Moje kosmetyki" : `${profileUser}`}
      {userProfile?.isProfessional && professionalUser}
      <div
        style={{
          fontSize: 12,
          textAlign: "justify",
          paddingLeft: 50,
          paddingRight: 50,
        }}
      >
        {userProfile?.description}
        {userProfile?.url && (
          <a href={userProfile.url} target="_blank" rel="noreferrer">
            {" "}
            Zobacz stronę
          </a>
        )}
      </div>
    </div>
  );
};

export default UserHeader;
